export default {
	HELLO: "native-event:hello",
	KEYBOARD_WILL_SHOW: "native-event:keyboard-will-show",
	KEYBOARD_WILL_HIDE: "native-event:keyboard-will-hide",
	STATUSBAR_TAPPED: "native-event:statusbar-tapped",
	APP_READY: "native-event:app-ready",
};
